import { ReduxStore } from '~/App/shared/interfaces/store';
import { memberIdSelector } from '~/App/shared/selectors/sessionSelector';
import { useSelector } from 'react-redux';

export const useUserId = () => useSelector(memberIdSelector);

export const getUserId = (state: ReduxStore) => memberIdSelector(state);
